module.exports = __webpack_public_path__ + "img/2-1.5fec5e6a.svg";